import type { SVGProps } from "react";
// generated from ArrowNarrowUpRight.svg — do not edit manually
// prettier-ignore
export default function ArrowNarrowUpRight(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 7.5 6 L 18 6 M 18 6 L 18 16.5 M 18 6 L 6 18" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
